import { transaction, observable } from 'mobx';
import { ISelectedAnimManager } from './selected-anim-manager.interface';

class SelectedAnimManager implements ISelectedAnimManager {
    @observable _selectedArray = [] as Array<any>;

    public get length() {
        return this.selectedArray.length;
    }

    public get selectedArray() {
        return this._selectedArray;
    }

    public add(...items) {
        transaction(() => {
            items.forEach((item) => {
                if (item && this.findItem(item) === false) {
                    item.selected = true;
                    this.selectedArray.push(item);
                }
            });
        });
    }

    public remove(...items) {
        transaction(() => {
            items.forEach((item) => {
                item.selected = false;
                const index = this.selectedArray.indexOf(item);
                if (index !== -1) {
                    this.selectedArray.splice(index, 1);
                }
            });
        });
    }

    public objectAtIndex(index) {
        return this.selectedArray[index];
    }

    public indexOfObject(item) {
        if (item) {
            return this.selectedArray.indexOf(item);
        }
        return -1;
    }

    public clear() {
        transaction(() => {
            this.selectedArray.forEach((item) => {
                item.selected = false;
            });
            this.selectedArray.splice(0, this.selectedArray.length);
        });
    }

    public clearAndAdd(...items) {
        transaction(() => {
            this.selectedArray.forEach((item) => {
                item.selected = false;
            });
            this.selectedArray.splice(0, this.selectedArray.length);

            items.forEach((item) => {
                item.selected = true;
                this.selectedArray.push(item);
            });
        });
    }

    // Private Methods
    public findItem(item) {
        return this._selectedArray.indexOf(item) !== -1;
    }
}

export default SelectedAnimManager;
